import React, { useEffect } from 'react';
import withRouter from '.././components/withRouter';

//redux
import { useSelector } from "react-redux";
import { createSelector } from 'reselect';
import { ToastContainer } from 'react-toastify';

const NonAuthLayout = ({ children } : any) => {

    const nonauthData = createSelector(
        (state: any) => state.Layout,
        (layoutModeType: any) => layoutModeType.layoutModeType
      );
    // Inside your component
    const layoutModeType = useSelector(nonauthData);

    useEffect(() => {
        if (layoutModeType === "dark") {
            document.body.setAttribute("data-bs-theme", "dark");
        } else {
            document.body.setAttribute("data-bs-theme", "light");
        }
        return () => {
            document.body.removeAttribute("data-bs-theme");
        };
    }, [layoutModeType]);
    return (
        <>
            {children}
            <ToastContainer
                autoClose={3000}
                position={"top-right"}
                hideProgressBar={false}
                closeOnClick={true}
                pauseOnFocusLoss={true}
                draggable={false}
                theme={"light"}
            />
        </>
    );
};

export default withRouter(NonAuthLayout);